import { logAskPaperViaRedirect } from "helpers/services/mixpanel";
import { useAppDispatch, useAppSelector } from "hooks/useStore";
import { useRouter } from "next/router";
import { useEffect } from "react";
import {
  AskPaperDrawerSettings,
  setAskPaperDrawerSettings,
} from "store/slices/setting";

function useAskPaperDrawer() {
  const router = useRouter();

  const askPaperDrawerSettings = useAppSelector(
    (state) => state.setting.askPaperDrawer
  );

  const dispatch = useAppDispatch();

  // This is used to open the ask paper drawer from the research hub
  // It is triggered when the user uploads a new paper and the upload is successful
  useEffect(() => {
    if (router.query.openAskPaperDrawer) {
      logAskPaperViaRedirect(router.query.paperId as string);
      openAskPaperDrawer({
        paperId: router.query.paperId as string,
        title: router.query.title as string,
        fullTextURL: router.query.fullTextURL as string,
        isAskPaperDrawerOpen: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    router.query.openAskPaperDrawer,
    router.query.paperId,
    router.query.title,
    router.query.fullTextURL,
  ]);

  const openAskPaperDrawer = ({
    paperId,
    title,
    fullTextURL,
  }: Partial<AskPaperDrawerSettings>) => {
    dispatch(
      setAskPaperDrawerSettings({
        isAskPaperDrawerOpen: true,
        paperId: paperId,
        title: title,
        fullTextURL: fullTextURL,
      })
    );
  };

  const closeAskPaperDrawer = () => {
    dispatch(
      setAskPaperDrawerSettings({
        isAskPaperDrawerOpen: false,
        paperId: undefined,
        title: undefined,
        fullTextURL: undefined,
      })
    );
  };

  return {
    ...askPaperDrawerSettings,
    openAskPaperDrawer,
    closeAskPaperDrawer,
  };
}

export default useAskPaperDrawer;
